<template>
  <div>
    <section class="hero is-primary">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            Yoshimura Webshop 2000
          </h1>
          <h2 class="subtitle">
            Hi welcome to my Webshop
          </h2>
        </div>
      </div>
    </section>
    <br>
    <div class="columns is-mobile is-multiline">
      <div
        v-for="product in products"
        :key="product.name"
        class="column is-full-mobile is-half-tablet is-one-third-desktop is-one-quarter-fullhd"
      >
        <product-card :product-info="product" />
      </div>
    </div>
  </div>
</template>

<script>
import ProductCard from '../components/ProductCard'

export default {
  name: 'Home',
  components: {
    ProductCard
  },
  data () {
    return {
      products: [
        {
          name: 'Masks',
          images: [
            'img/masks/IMG_1238.JPG',
            'img/masks/IMG_1284.JPG',
            'img/masks/IMG_1364.JPG',
            'img/masks/IMG_2104.JPG',
            'img/masks/IMG_1193.jpg'
          ],
          description: 'All masks are handcrafted. fabrics and design can be individually selected.',
          routeName: 'Masks'
        },
        {
          name: 'Stamps',
          images: [
            'img/stamps/IMG_1002.JPG',
            'img/stamps/IMG_1106.JPG',
            'img/stamps/IMG_1107.JPG',
            'img/stamps/IMG_1131.JPG'
          ],
          description: 'The stamps are carved into rubber pads.',
          routeName: 'Stamps'
        },
        {
          name: 'Cards',
          images: [
            'img/cards/IMG_0244.JPG',
            'img/cards/IMG_0255.JPG',
            'img/cards/IMG_1201.JPG',
            'img/cards/IMG_0782.JPG',
            'img/cards/IMG_1111.JPG'
          ],
          description: 'Birthday-, Wedding-, Gratulation Cards with water-based paint, combined with origami.',
          routeName: 'Cards'
        },
        {
          name: 'Origami',
          images: [
            'img/origami/IMG_0260.JPG',
            'img/origami/IMG_0470.JPG',
            'img/origami/IMG_1217.JPG',
            'img/origami/IMG_1289.JPG'
          ],
          description: 'You will be amazed what you can create out of paper. Decoration, lamps, or ear rings, you name it yoshie crafts it.',
          routeName: 'Origami'
        },
        {
          name: 'Other fabrics',
          images: [
            'img/baby/IMG_1806.JPG',
            'img/baby/IMG_2069.JPG',
            'img/baby/IMG_2070.JPG'
          ],
          description: 'Baby articles of all kind.'
        }
      ]
    }
  }
}
</script>
